/**
 * @file index.js
 * @description React 앱의 진입점입니다. DOM 루트에 앱을 마운트하고 전역 스타일을 로드합니다.
 * 라우팅은 react-router-dom이 아닌 useAppRouter(history.pushState 기반 커스텀 구현)를 사용합니다.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import App from './App';
import ContentProvider from './content/ContentProvider';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ContentProvider>
      <App />
    </ContentProvider>
  </React.StrictMode>
);

reportWebVitals();
